import { FormattedMessage } from 'react-intl';
import { PaymentElement } from '@stripe/react-stripe-js';
import { StripePaymentElementOptions } from '@stripe/stripe-js';
import { StripeFormProps } from './types';

const PAYMENT_ELEMENT_OPTIONS = {
  fields: {
    billingDetails: {
      address: 'never',
    },
  },
} as const satisfies StripePaymentElementOptions;

export const StripeForm = ({ isDisabled }: StripeFormProps) => (
  <fieldset>
    <legend className="mb-0">
      <h2 className="h5" style={{ fontSize: '1.25rem' }}>
        <FormattedMessage
          id="payment.billing.information.form.heading"
          defaultMessage="Billing Information (Required)"
          description="Heading for Billing Form"
        />
      </h2>
    </legend>
    <PaymentElement
      options={{ ...PAYMENT_ELEMENT_OPTIONS, readOnly: isDisabled }}
      id="payment-element"
    />
  </fieldset>
);
